import {
  ProfileHero
} from '@paddl/storybook';
import {
  getHumanisedNumber
} from '@paddl/utils-js';
import t from 'prop-types';
import React, { useEffect } from 'react';
import { Layout, TabContent } from '../';
import Page404 from '../../pages/404';
import {
  ProfilePageWrapper
} from '../../styles/pages/profile.styles';
import {
  submitProfilePageViews
} from '../../utils';
import { TimelineTabPanel, SummaryTabPanel} from '@paddl/utils-react';

export const PublicProfilePage = ({
    profile, memberStats, timeline
  }) => {

    const { fullName, title, location,
    avatarUrl, profileId, urlSlug, bannerUrl} = profile;

    const { skillsCount, totalXp, activitiesCount } = memberStats

    useEffect(() => {
      submitProfilePageViews(profileId);
    }, [profileId]);

    if (!profile) return <Page404 data-test-id="404-page" />;

    const descriptionElements = [];
    descriptionElements.push(`
    View ${fullName}'s professional experience profile on Paddl.`)

    if (activitiesCount > 0) {
      descriptionElements.push(`They have earned ${getHumanisedNumber(
        totalXp
      )} XP and progressed ${skillsCount} Skill${
        skillsCount > 1 ? 's' : ''
      } from ${activitiesCount} ${
        activitiesCount > 1 ? 'activities' : 'activity'
      }.`)
    }
    descriptionElements.push('Login or Sign up to discover more experience analytics.')

    return (
      <ProfilePageWrapper>
        <Layout
          pageTitle={`${fullName} ${location ? `- ${location}` : ''}`}
          pageDescription={descriptionElements.join('\n')}
          pagePathname={`/xp/${urlSlug || profileId}`}
          pageType="profile"
          pageMetaImageUrl={avatarUrl}
          navigationTitle={fullName ? `${fullName} Profile` : ''}
        >
          <div>
            <ProfileHero
              profileDetails={{
                fullName,
                location,
                avatarUrl,
                profileTitle: title
              }}
              headlineElements={{
                fullName: 'h1',
                profileTitle: 'h2',
                location: 'h3',
                profileStats: 'h3'
              }}
              profileStats={{
                totalXp: totalXp,
                totalActivities: activitiesCount ,
                totalSkills: skillsCount
              }}
              backgroundImage={bannerUrl}
            />
            <TabContent
              activities={<TimelineTabPanel timeline={timeline} isPublic/>
              }
              summary={
                 <SummaryTabPanel profile={profile} activitiesCount={activitiesCount} />
              }
            />
          </div>
        </Layout>
      </ProfilePageWrapper>
    );
  };

PublicProfilePage.propTypes = {
  profile: t.shape({
    profileId: t.number,
    fullName: t.string,
    aboutMe: t.string,
    links: t.array,
    bannerUrl: t.string,
    urlSlug: t.string,
    title: t.string,
    location: t.string,
    avatarUrl: t.string
  }),
  memberStats: t.shape({
    skillsCount: t.number, totalXp: t.number, activitiesCount: t.number
  }),
  timeline: t.array
}
